


const close = () => {
    document.body.dataset.synopsis = 'closed';
};

const open = () => {
    document.body.dataset.synopsis = 'open';
};



{
    const openElement = document.getElementById('synopsis-open');
    if (openElement) {
        openElement.addEventListener('click', event => {
            event.preventDefault();
            open();
            singleton.dispatchEvent('opened');
        });
    }

    const closeElement = document.getElementById('synopsis-close');
    if (closeElement) {
        closeElement.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();
            close();
            singleton.dispatchEvent('closed');
        });
    }

    let backgroundElement = document.querySelectorAll('.synopsis');
    if (backgroundElement) {
        backgroundElement = Array.from(backgroundElement);
        backgroundElement.forEach(item => {
            item.addEventListener('click', event => {
                if (event.target === item) {
                    close();
                    singleton.dispatchEvent('closed');
                }
            });
        });
    }
}

const singleton = {};
createjs.EventDispatcher.initialize(singleton);

module.exports = singleton;



// WEBPACK FOOTER //
// ./js/synopsis.js